export const TRAITS = [
  'thoughtful',
  'easygoing',
  'intellectual',
  'talanted',
  'logical',
  'calm',
  'energetic',
  'manageable',
  'masterful',
  'modest',
  'expressive',
  'polite',
  'confident',
  'brave',
  'impassive',
  'sensitive',
  'trustful',
  'cautious',
  'practical',
  'dreamy',
  'forthright',
  'diplomatic',
  'balanced',
  'progressive',
  'passionate',
  'tactful',
  'relaxed',
  'tense',
  'kindly',
  'conscientious',
  'cheery',
  'careful',
  'talky',
  'purposeful',
  'sympathetic',
  'measured',
  'coldblooded',
  'dignified',
  'accurate',
  'creative',
  'persistent',
  'responsible',
  'carefree',
  'artistic',
  'shy',
  'loyal',
  'spontaneous',
  'quiet',
  'wise',
  'sweet',
];

export const MAX_TRAITS = 7;
